import { Component } from '@angular/core';

@Component({
  selector: 'app-resume-builder-section',
  templateUrl: './resume-builder-section.component.html',
  styleUrls: ['./resume-builder-section.component.css'],
})
export class ResumeBuilderSectionComponent {}
